import React from "react";
import { Formik, FormikProps } from "formik";
import { Grid } from "@material-ui/core";
import * as Yup from "yup";

import { Values } from "Tools/Values";
import { STFormWrapper } from "@src/Components/Ui/STFormWrapper";
import renderCommonFormField from "@src/Components/Common/FormFields/renderCommonFormField";
import FormSwitch from "@src/Components/Common/FormFields/FormSwitch/FormSwitch";
import { inject, observer } from "mobx-react";
import { IValuesStore } from "@src/Stores/Values/types";
import { IManagementStore } from "@src/Stores/Management/types";
import { STFormTitleTypography } from "@src/Components/Ui/STFormTitleTypohraphy";
import { ButtonsForm } from "@src/Components/Common/ButtonsForm/ButtonsForm";
import { PositionTeam } from "@src/Interfaces/Entity/PositionTeam";
import TransferList from "@src/Components/Common/TransferList/TransferList";
import { computed } from "mobx";
import { STGrid } from "./styles";
import { STContentWrapper } from "@src/Components/Common/SimpleModal/styles";

const positionTeamSchema = (positionTeams: PositionTeam[]) =>
  Yup.object().shape({
    name: Yup.string()
      .required(() => {
        return Values.getLocalizationValue("fieldRequired");
      })
      .test("isNameExists", Values.getLocalizationValue("nameAlreadyExists"), function(value) {
        if (!value) {
          return true;
        }
        const filteredPositionTeams = positionTeams.filter(positionTeam => positionTeam.name === value);
        if (filteredPositionTeams.length === 0) {
          return true;
        }
        if (
          this.parent.id !== "00000000-0000-0000-0000-000000000000" &&
          filteredPositionTeams[0].id === this.parent.id
        ) {
          return true;
        }
        return false;
      }),
    positions: Yup.array()
      .of(Yup.string())
      .required(() => {
        return Values.getLocalizationValue("fieldContain");
      }),
  });

interface IProps {
  title: string;
  initialValues: PositionTeam;
  onSubmit: (values: PositionTeam) => void;
  onClose: () => void;
  values?: IValuesStore;
  management?: IManagementStore;
}

@inject("values", "management")
@observer
class PositionTeamForm extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
    if (this.props.initialValues.positions === null) {
      this.props.initialValues.positions = [];
    }
  }

  @computed get selectedPositions() {
    return this.props.initialValues.positions
      .map((positions: string) => {
        return this.props.management.activePositions.find(_ => _.id === positions);
      })
      .filter(item => item);
  }

  render() {
    return (
      <Formik
        initialValues={this.props.initialValues}
        validationSchema={() => positionTeamSchema(this.props.management.positionTeams)}
        onSubmit={this.props.onSubmit}
        render={(formikProps: FormikProps<PositionTeam>) => (
          <STFormWrapper onSubmit={formikProps.handleSubmit}>
            <STFormTitleTypography>{this.props.title}</STFormTitleTypography>
            <STContentWrapper>
              <Grid container>
                <Grid item xs={6}>
                  {renderCommonFormField<PositionTeam>("name", Values.getLocalizationValue("name"), formikProps)}
                </Grid>
                <Grid item xs={8}>
                  {renderCommonFormField<PositionTeam>(
                    "description",
                    Values.getLocalizationValue("description"),
                    formikProps
                  )}
                </Grid>
              </Grid>
              <STGrid container spacing={16} justify="flex-start" alignItems="center">
                <Grid item>{Values.getLocalizationValue("active")}</Grid>
                <Grid item>
                  <FormSwitch<PositionTeam>
                    trueAs={this.props.values.states.Active}
                    falseAs={this.props.values.states.Deactivated}
                    fieldName="state"
                    formikProps={formikProps}
                  />
                </Grid>
              </STGrid>

              <TransferList
                fieldName="positions"
                label={Values.getLocalizationValue("positions")}
                formikProps={formikProps}
                allItems={this.props.management.activePositions}
                selectedItems={this.selectedPositions}
                keyAsValue="id"
                keyAsTitle="name"
              />
            </STContentWrapper>
            <ButtonsForm onSubmit={formikProps.handleSubmit} onClose={this.props.onClose} />
          </STFormWrapper>
        )}
      />
    );
  }
}

export default PositionTeamForm;
